import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {UrlService} from '../url.service';

@Injectable()
export class ExternalContactService {
    private readonly BASE_URL: string;
    private readonly TAGS_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/clients';
        this.TAGS_URL = this.urlService.getBackendUrl() + 'data/tags';
    }

    getOverlapAllowedForCode(tagCode, externalContactsConfiguration) {
        if ((externalContactsConfiguration) && (externalContactsConfiguration.configurations[tagCode])) {
            if (externalContactsConfiguration.configurations[tagCode].overlapAllowed) {
                return externalContactsConfiguration.configurations[tagCode].overlapAllowed
            }
        }
        return true;  // default behavior.
    }

    getOutOfDateAllowedForCode(tagCode, externalContactsConfiguration) {
        if ((externalContactsConfiguration) && (externalContactsConfiguration.configurations[tagCode])) {
            if (externalContactsConfiguration.configurations[tagCode].outOfDateAllowed) {
                return externalContactsConfiguration.configurations[tagCode].outOfDateAllowed
            }
        }
        return false;  // default behavior.
    }

    getExternalContact(clientId, externalContactId) {
        return this.http.get(this.BASE_URL + '/' + clientId + '/externalContacts/' + externalContactId);
    }

    loadExternalContacts(clientId, activeOnly, applyDisplayFilter) {
        let params: HttpParams = new HttpParams();

        params = params.append('identifierMatch', 'false');
        params = params.append('activeOnly', (activeOnly === true ? 'true' : 'false'));
        params = params.append('applyDisplayFilter', (applyDisplayFilter === true ? 'true' : 'false'));

        const requestOptions = {
            params: params
        };

        return this.http.get(this.BASE_URL + '/' + clientId + '/externalContacts', requestOptions);
    }

    createNewExternalContact(clientId, tagCode) {
        let params: HttpParams = new HttpParams();

        params = params.append('tagCode', tagCode);

        const requestOptions = {
            params: params
        };

        return this.http.get(this.BASE_URL + '/' + clientId + '/externalContacts/create', requestOptions);
    }

    saveExternalContact(clientId, externalContactId, externalContact) {
        let params: HttpParams = new HttpParams();

        params = params.append('identifierMatch', false);

        const requestOptions = {
            params: params
        };

        return this.http.put(this.BASE_URL + '/'
            + clientId + '/externalContacts/' + externalContactId, externalContact, requestOptions);
    }

    removeExternalContact(clientId, externalContactId) {
        let params: HttpParams = new HttpParams();

        params = params.append('identifierMatch', false);

        const requestOptions = {
            params: params
        };

        return this.http.delete(this.BASE_URL + '/'
            + clientId + '/externalContacts/' + externalContactId, requestOptions);
    }

    getExternalContactTypes() {
        return this.http.get(this.TAGS_URL + '/forExternalContacts');
    }

    findSingleActiveContactName(externalContacts, tagCode) {
        if ((externalContacts == null) || (tagCode == null)) {
            return null;
        }

        let ec = null;
        externalContacts.forEach((externalContact) => {
            if (externalContact.tag.code === tagCode) {
                const soFarSoGood = true;
                if ((externalContact.startDate == null) || (!moment().isBefore(moment(externalContact.startDate)))) {
                    if ((externalContact.endDate == null) || (!moment().isAfter(moment(externalContact.endDate)))) {
                        ec = externalContact;
                        return;
                    }
                }
            }
        });

        if (ec == null) {
            return null;
        } else {
            return ec.lastName + ', ' + ec.firstName;
        }
    }

    isContactOutOfDate(externalContact, clientPlacements) {
        // If this is not an internal OrgUnit the message will never apply.
        if (externalContact.orgUnit == null) {
            return false;
        }

        if ((externalContact.endDate != null)
            && (moment().isAfter(moment(externalContact.endDate)))) {
            return false;
        }

        let foundOu = null;
        if (clientPlacements) {
            clientPlacements.forEach((clientPlacement) => {
                if ((externalContact.orgUnit.id === clientPlacement.orgUnit.id) && (clientPlacement.endDate == null)) {
                    foundOu = clientPlacement.orgUnit;
                }
            });
        }

        if (foundOu == null) {
            return true;
        }

        return false;
    }
}
